import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { PERIODOS_RESUMO_ADMIN_TAREFAS, PeriodoResumoAdminTarefas } from "@/types/tarefa.type";

export function PeriodoTarefaSelect({
  value,
  onChange,
}: {
  value: PeriodoResumoAdminTarefas;
  onChange: (dias: PeriodoResumoAdminTarefas) => void;
}) {
  return (
    <Select
      value={String(value)}
      onValueChange={(v) => onChange(Number(v) as PeriodoResumoAdminTarefas)}
    >
      <SelectTrigger className="w-[160px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {PERIODOS_RESUMO_ADMIN_TAREFAS.map((periodo) => (
          <SelectItem key={periodo} value={String(periodo)}>
            Últimos {periodo} dias
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
